export class ResourceCity {
    constructor(obj: any = null){
        if(obj) {
            this.code = obj.code || "";
            this.shortName = obj.shortName || "";
            this.fullName = obj.fullName || "";
        }
    };

    code: string = "";
    shortName: string = "";
    fullName: string = "";
}

export class ResourceState {
    constructor(obj: any = null){
        if(obj) {
            this.code = obj.code || "";
            this.abbrev = obj.abbrev || "";
            this.name = obj.name || "";
        }
    };
    
    code: string = "";
    abbrev: string = "";
    name: string = "";
}

export class ResourceCountry {
    constructor(obj: any = null){
        if(obj) {
            this.code = obj.code || "";
            this.name = obj.name || "";
        }
    };
    
    code: string = "";
    name: string = "";
}

export class ResourceSeatLocation {
    constructor(obj: any = null){
        if(obj) {
            this.code = obj.code || "";
            this.name = obj.name || "";
        }
    };
    
    code: string = "";
    name: string = "";
}

export class ResourceSeatType {
    constructor(obj: any = null){
        if(obj) {
            this.code = obj.code || "";
            this.name = obj.name || "";
        }
    };
    
    code: string = "";
    name: string = "";
}

export class ResourceData {
    constructor(obj: any = null){
        if(obj) {
            this.usStates = (obj.usStates || []).map((x: any) => new ResourceState(x));
            this.cities = (obj.cities || []).map((x: any) => new ResourceCity(x));
            this.countries = (obj.countries || []).map((x: any) => new ResourceCountry(x));
            this.seatLocations = (obj.seatLocations || []).map((x: any) => new ResourceSeatLocation(x));
            this.seatTypes = (obj.seatTypes || []).map((x: any) => new ResourceSeatType(x));
        }
    };
    
    usStates: ResourceState[] = [];
    cities: ResourceCity[] = [];
    countries: ResourceCountry[] = [];
    seatLocations: ResourceSeatLocation[] = [];
    seatTypes: ResourceSeatType[] = [];
}

export interface INameToStringFunctionMap {
    [key: string]: Function<string>;
}

export interface INameToStringMap {
    [key: string]: string;
}

export interface IErrorStrings {
    en: {
        messages: INameToStringFunctionMap,
        attributes: INameToStringMap
    }
}